import { formatNotificationResults, formatNotificationSettings } from './format';
import { formatPagingParams, handleError } from '../common/services/helpers';

import API from '/b2b/common/helpers/API';
import { API_NAME } from '#config/runtimeconfig';

export const fetchNotifications = (params = {}) => {
    const { filters: { unreadOnly = true, eventType } = {} } = params;

    const options = {
        queryStringParameters: {
            ...formatPagingParams(params),
            unreadOnly: !!unreadOnly,
            eventType,
        },
    };
    return API.get(API_NAME, '/notifications', options)
        .catch(handleError)
        .then(formatNotificationResults);
};

export const markAllNotificationsRead = () => {
    const options = {};
    return API.post(API_NAME, '/notifications/read', options).catch(handleError);
};

export const markNotificationById = (notificationId, params = {}) => {
    const { read = true } = params;
    const options = {
        body: { read },
    };
    return API.post(API_NAME, `/notification/${notificationId}/read`, options).catch(handleError);
};

export const fetchUserNotifications = () => {
    return API.get(API_NAME, `/user/prefs/notification`, {})
        .catch(handleError)
        .then(formatNotificationSettings);
};

export const fetchCustUserNotifications = userId => {
    return API.get(API_NAME, `/customer/user/${userId}/notifications`, {})
        .catch(handleError)
        .then(formatNotificationSettings);
};

export const updateUserNotifications = settings => {
    const options = {
        body: settings,
    };

    return API.put(API_NAME, `/user/prefs/notification`, options)
        .catch(handleError)
        .then(response => response || settings)
        .then(formatNotificationSettings);
};

export const updateCustUserNotifications = (userId, settings) => {
    const options = {
        body: settings,
    };

    return API.put(API_NAME, `/customer/user/${userId}/notifications`, options)
        .catch(handleError)
        .then(response => response || settings)
        .then(formatNotificationSettings);
};
